import React, { useEffect, useState } from "react";

// Live ticking countdown to a target Date. Shows Days/Hrs/Min/Sec segments.
export default function Countdown({ target, testid = "countdown" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, Math.floor((new Date(target).getTime() - now) / 1000));
  const d = Math.floor(diff / 86400);
  const h = Math.floor((diff % 86400) / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = diff % 60;

  if (diff <= 0) return <span data-testid={testid} className="font-display font-bold text-emerald-400">Starting now…</span>;

  const seg = (val, label) => (
    <div className="flex flex-col items-center min-w-[38px]">
      <span className="font-display font-black text-2xl sm:text-3xl tabular-nums leading-none text-white">{String(val).padStart(2, "0")}</span>
      <span className="overline text-zinc-500 mt-1">{label}</span>
    </div>
  );

  return (
    <div data-testid={testid} className="flex items-center gap-2 sm:gap-3">
      {d > 0 && (<>{seg(d, "Days")}<span className="text-zinc-600 font-black text-2xl -mt-3">:</span></>)}
      {seg(h, "Hrs")}
      <span className="text-zinc-600 font-black text-2xl -mt-3">:</span>
      {seg(m, "Min")}
      <span className="text-zinc-600 font-black text-2xl -mt-3">:</span>
      {seg(s, "Sec")}
    </div>
  );
}
